import script from "./OnboardingAiLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiLayout.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiLayout.vue?vue&type=style&index=0&id=6e37fa86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e37fa86"]])

export default __exports__